export default {
  // Module title
  otpPerformance: 'Zamanında Varış Performansı',

  // Tab labels
  byDate: 'Tarihe Göre',
  byRoute: 'Rotaya Göre',
  byStops: 'Duraklara Göre',

  // Filter labels
  dateRange: 'Tarih Aralığı',
  routes: 'Rotalar',
  allRoutes: 'Tüm Rotalar',
  drivers: 'Sürücüler',
  allDrivers: 'Tüm Sürücüler',
  direction: 'Yön',
  allDirections: 'Tüm Yönler',
  inbound: 'Gelen',
  outbound: 'Giden',
  loop: 'Çevrim',
  stopType: 'Durak Tipi',
  firstStopOnly: 'Sadece İlk Durak',
  allStops: 'Tüm Duraklar',
  lastStopOnly: 'Sadece Son Durak',

  // Threshold
  lateArrivalThreshold: 'Geç Varış Eşiği',

  // Sort options
  sortBy: 'Sırala',
  onTimeAscending: 'Zamanında (Artan)',
  onTimeDescending: 'Zamanında (Azalan)',
  lateAscending: 'Geç (Artan)',
  lateDescending: 'Geç (Azalan)',
  earlyAscending: 'Erken Kalkış (Artan)',
  earlyDescending: 'Erken Kalkış (Azalan)',

  // Status labels
  late: 'Geç',
  lateArrival: 'Geç Varış',
  onTime: 'Zamanında',
  early: 'Erken',
  earlyDeparture: 'Erken Kalkış',
  skipped: 'Atlandı',
  leftBehind: 'Geride Bırakılan',
  otherRoutes: 'Diğer rotalar ({count})',
  riders: 'Yolcu',

  // Metrics
  onTimePerformance: 'Zamanında Varış Performansı',
  totalStops: 'Toplam Durak',
  total: 'Toplam',
  stops: 'Durak',
  maxLateDeviation: 'Maks. Geç Kalma',
  maxEarlyDeviation: 'Maks. Erken Kalkış',
  mins: 'dk',

  // Chart labels
  lateDeviationMin: 'Geç Kalma Sapması (dk)',
  earlyDeviationMin: 'Erken Kalkış Sapması (dk)',
  onTimePerformancePercent: 'Zamanında Varış Performansı (%)',
  lateArrivalThresholdLabel: 'Geç varış eşiği',
  minutes: 'dakika',

  // Actions
  showMore: 'Daha Fazla Göster',
  showLess: 'Daha Az Göster',
  viewRoute: 'Rotayı Görüntüle',

  // Tooltip labels
  lateArrivalStops: 'Geç Varış Durakları',
  earlyDepartureStops: 'Erken Kalkış Durakları',
  skippedStops: 'Atlanan Duraklar',
  totalDepartures: 'Toplam Kalkış',

  // Percentages
  percentage: '%',

  // Messages
  noDataAvailable: 'Seçili filtreler için veri mevcut değil',
  noTripsOnDate: 'Bu tarihte sefer yok',
  noTripsInPeriod: 'Bu dönemde sefer yok',
  loadingData: 'Veriler yükleniyor...',
  errorLoadingData: 'Veri yüklenirken hata oluştu. Lütfen tekrar deneyin.',
  backToRoutes: 'Rotalara geri dön',
};
